<template>
	<div class="page merci">
		<div class="logo">
			<img src="../assets/logo.png" />
		</div>
		<h1>
			Selon les données renseignées,
			<br />nous avons estimé le coût de construction
			<br />dans la fourchette de prix suivante :
		</h1>
		<div class="fourchette">{{$store.state.fourchette_estimative}}</div>
		<div class="paragraphe">
			Retrouvez tous les détails de cette offre
			<br />dans l'email qui vient de vous être envoyé.
			<br />Pour plus d'informations,
			<br />n'hésitez pas à venir nous parler.
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import { Plugins } from "@capacitor/core";

	export default {
		name: "Merci",
		components: {},
		data() {
			return {
				timer: 0,
				myInterval: null
			};
		},
		beforeMount() {
			this.timer = 0;
		},
		methods: {
			startInterval() {
				this.myInterval = setInterval(() => {
					this.timer = this.timer + 1;
					if (this.timer > 20) {
						this.timer = 0;
						this.$store.commit("resetState");
						this.$router.push({ path: "/" });
					}
				}, 1000);
			},
			stopInterval() {
				clearInterval(this.myInterval);
			}
		},
		mounted() {
			this.startInterval();
			this.$store.commit("setTimer", 21);
		},
		beforeDestroy() {
			this.stopInterval();
		}
	};
</script>

<style lang="less">
	.merci {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		text-align: center;
		flex-direction: column;
		padding-top: 50px;
		.logo {
			margin-bottom: 50px;
		}
		h1,
		.paragraphe {
			font-weight: bold;
			color: black;
			font-size: 16px;
		}
		.fourchette {
			font-size: 40px;
			font-weight: bold;
			line-height: 50px;
			color: white;
			margin: 40px 0 40px 0;
		}
	}
</style>
